export const DEFAULT_CHAT_MODEL: string = "chat-model";

export type ChatModel = {
  id: string;
  name: string;
  description: string;
};

export const chatModels: ChatModel[] = [
  {
    id: "chat-model",
    name: "GPT OSS 120B",
    description: "Strong multilingual reasoning",
  },    
  {
    id: "chat-model-llama",
    name: "Llama 3.1 70B",
    description: "Balanced performance & reasoning",
  },
  {
    id: "chat-model-qwen",
    name: "Qwen3 235B",
    description: "Fast multimodal agent tasks",
  },
  {
    id: "chat-model-openai",
    name: "GPT OSS 20B",
    description: "Efficient coding & logic",
  },      
];
